export var isConditionValueEmpty = function isConditionValueEmpty(condition, conditionType, path, value) {
  var _a;

  if (!path) {
    return true;
  }

  var conditionValue = (_a = value === null || value === void 0 ? void 0 : value.conditions) === null || _a === void 0 ? void 0 : _a.find(function (conditionValueItem) {
    return conditionValueItem.name === path;
  });
  return conditionType.isValueEmpty(condition, conditionValue);
};